import axios from "./axios-handler.service";
import { Categoria } from "./categorias.service";
const BASE_URL = "/api/Produtos";
export interface ImagemProduto {
  idImagemProduto: string;
  idProduto: string;
  nomeArquivo: string;
  ordem: number;
  principal: boolean;
  dataCadastro: string;
}
export interface ItemKit {
  idItemKit: string;
  idProduto: string;
  idProdutoPai: string;
  quantidade: number;
  valorVenda: number;
  produto: Produto;
}
export interface Produto {
  idProduto?: string;
  idCatalogo?: string;
  descricao?: string;
  codigoFornecedor?: string;
  valorVenda?: number;
  secao?: number;
  validoApos?: string;
  dataAlteracao?: string;
  dataCriacao?: string;
  idCategoria?: string;
  excluido?: boolean;
  exclusivoDiretora?: boolean;
  mostraVenda?: boolean;
  servico?: boolean;
  imagensProduto?: ImagemProduto[];
  categoria?: Categoria;
  tipo?: number;
  ehKit?: boolean;
  items?: ItemKit[];
  alertaVencimentoEmDias?: number | null;
}
export interface FiltrosProdutos {
  idCatalogo: string;
  nome: string;
  descricao: string;
  codigoFornecedor: string;
  idCategoria: string | null;
  ativos: boolean | null;
  sImagens: boolean | null;
  soKit: boolean | null;
}

export interface AdicionarItemKitCommand {
  idProdutoPai: string;
  idProduto: string;
  quantidade: number;
}

export interface AlterarPrecoImportacaoCommand {
  valor: number;
  validoApos: string;
  idCatalogo: string;
  codigoFornecedor: string;
}

export class ProdutosService {
  static async listarProdutosDoCatalogo(
    filters: FiltrosProdutos,
  ): Promise<Produto[]> {
    const { idCatalogo, descricao, codigoFornecedor, ativos, sImagens, soKit } =
      filters;
    let { idCategoria } = filters;
    if (idCategoria == null) {
      idCategoria = "";
    }
    const response = await axios.get<Produto[]>(
      `${BASE_URL}/ListarProdutosDoCatalogo`,
      {
        params: {
          idCatalogo,
          idCategoria,
          descricao,
          codigoFornecedor,
          ativos,
          sImagens,
          soKit,
        },
      },
    );
    return response.data;
  }
  static async listarProdutosDoCatalogoSemKit(
    idCatalogo: string,
    descricao: string,
  ): Promise<Produto[]> {
    const response = await axios.get<Produto[]>(
      `${BASE_URL}/ListarProdutosDoCatalogoSemKit`,
      {
        params: {
          idCatalogo,
          descricao,
        },
      },
    );
    return response.data;
  }

  static async manterProduto(produto: Produto): Promise<Produto> {
    const response = await axios.post<Promise<Produto>>(
      BASE_URL + "/ManterProduto",
      produto,
    );
    return response.data;
  }

  static async manterProdutoComHistorico(produto: Produto): Promise<void> {
    await axios.post(BASE_URL + "/ManterProdutoComHistorico", produto);
  }

  static async obterProduto(id: string): Promise<Produto> {
    const response = await axios.get<Produto>(`${BASE_URL}/Obter`, {
      params: { id },
    });
    return response.data;
  }

  static async listarTipos(idCatalogo: string) {
    const response = await axios.get<{ key: number; value: string }[]>(
      `${BASE_URL}/ListarTipos`,
      {
        params: { idCatalogo },
      },
    );
    return response.data;
  }

  static async listarItemsDoKit(idProdutoPai: string): Promise<ItemKit[]> {
    const response = await axios.get<ItemKit[]>(
      `${BASE_URL}/ListarItemsDoKit`,
      {
        params: { idProdutoPai },
      },
    );
    return response.data;
  }

  static async adicionarItemKit(
    command: AdicionarItemKitCommand,
  ): Promise<void> {
    await axios.post(`${BASE_URL}/AdicionarItemKit`, command);
  }
  static async removerItemKit(idItemKit: string): Promise<void> {
    const response = await axios.post(`${BASE_URL}/RemoverItemKit`, {
      idItemKit,
    });
    return response.data;
  }

  static async alterarImagem(idProduto: string, base64: string): Promise<void> {
    const response = await axios.post(`${BASE_URL}/AlterarImagem`, {
      idProduto,
      base64,
    });
    return response.data;
  }

  static async AlterarProdutoComHistoricoNaImportacao(
    command: AlterarPrecoImportacaoCommand,
  ): Promise<void> {
    const response = await axios.put(
      `${BASE_URL}/AlterarProdutoComHistoricoNaImportacao`,
      command,
    );
    return response.data;
  }
}
